import type { iBreakpointsConfig } from "@rotorstudios/fe-ui";

export const BREAKPOINTS_CONFIG: iBreakpointsConfig = {
  xsDevice: undefined,
  sDevice: undefined,
  mobile: {
    minWidth: undefined,
    maxWidth: 1023,
    ratio: 16 / 9,
    orientation: [],
  },
  tablet: {
    minWidth: 1024,
    maxWidth: 1599,
    ratio: 3 / 4,
    orientation: [],
  },
  laptop: undefined,
  desktop: {
    minWidth: 1600,
    maxWidth: undefined,
    ratio: 4 / 3,
    orientation: [],
  },
  xlDevice: undefined,
  xxlDevice: undefined,
};

export const SOURCE_MEDIA_QUERIES = {
  mobile: "(max-width: 768px)",
  desktop: "(max-width: 769px)",
};
